import { render, staticRenderFns } from "./FirmaMultiplaComponent.vue?vue&type=template&id=6997814c"
import script from "./FirmaMultiplaComponent.vue?vue&type=script&lang=js"
export * from "./FirmaMultiplaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports